import { IModal } from '@/plugins/modal-manager';
import TombolaMinimisedModal from '@/components/home/_components/minimised-modal';

enum ModalEventType {
    Minimise,
    Restore
}

type IModalEventNotification = (modal: IModal, action: ModalEventType) => TombolaMinimisedModal;

export { IModalEventNotification, ModalEventType };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/home/_components/tombola-modal/_domain/modal-events/modal-events.ts